<template>
  <div class="tit">
    <span class="line" />
    <span class="box-title">{{ title }}</span>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .tit{
    .line{
      display: inline-block;
      width: 4px;
      height: 17px;
      background: #007FFF;
      margin-right: 11px;
      vertical-align: text-bottom;
    }
    .box-title{
      font-weight: bold;
      color: #333333;
      font-size: 18px;
    }
}
</style>
